import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0a3c2a3c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "manage_box"
};
var _hoisted_2 = {
  class: "container"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "manage_title"
  }, "管线与创新", -1);
});

var _hoisted_4 = {
  class: "rolage"
};
var _hoisted_5 = {
  class: "container_item_box"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = ["innerHTML"];
var _hoisted_8 = {
  class: "container_item_eng"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_swiper_slide = _resolveComponent("swiper-slide");

  var _component_swiper = _resolveComponent("swiper");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_swiper, {
    class: "swiper_container",
    autoplay: $setup.swiper_option.autoplay,
    loop: $setup.swiper_option.loop,
    speed: $setup.swiper_option.speed,
    pagination: {
      clickable: true
    },
    slidesPerView: $setup.swiper_option.showNum,
    modules: $setup.modules,
    ref: "swiperRef"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.InnovationList, function (item) {
        return _openBlock(), _createBlock(_component_swiper_slide, {
          key: item.id
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("div", {
              class: "manage_item",
              onClick: _cache[0] || (_cache[0] = function () {
                return $setup.jumpManage && $setup.jumpManage.apply($setup, arguments);
              })
            }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
              src: item.imageUrl,
              class: "container_item_img"
            }, null, 8, _hoisted_6), _createElementVNode("div", {
              class: "container_item_text",
              innerHTML: item.title
            }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, "(" + _toDisplayString(item.subTitle) + ")", 1)])])];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }, 8, ["autoplay", "loop", "speed", "slidesPerView", "modules"])])])]);
}